/**
 * TKP-87 / tasarım s.18 — organizasyonun satın alabileceği modüller. Backend karşılığı: `domain/modules/sellable/Sellable.ts`
 * (liste orada da tutulur ve satıştan kalkan modülün YENİ verilmesini backend reddeder).
 */
export const SELLABLE_MODULES = Object.freeze(["KVKK", "GDPR", "TASKS", "RISK"]);

/** Satıştan kalkan modüller: yeni verilemez; almış organizasyonun erişimi ve ekranları yerinde (geriye uyumluluk). */
export const RETIRED_MODULES = Object.freeze(["BGYS", "DDO", "TRAINING"]);

/** Uyum ÜRÜNÜ olmayan modüller: "hangi ürün?" seçimlerinde ürün olarak sunulmaz. */
export const NON_PRODUCT_MODULES = Object.freeze(["TASKS"]);

/**
 * Satış formunun seçenekleri: satıştaki modüller + bu organizasyonun ZATEN sahip olduğu eski modüller. Eskiler listede
 * olmazsa çoklu seçim onları göstermez ve "Kaydet" organizasyonun erişimini sessizce silerdi.
 */
export const moduleOptions = (owned) => [...SELLABLE_MODULES, ...RETIRED_MODULES.filter((module) => (owned || []).includes(module))];

export const isRetiredModule = (module) => RETIRED_MODULES.includes(module);

export const moduleLabelKey = (module) => `purchased-feature.modules.${module}`;

/** Organizasyonun uyum ürünleri (politika, dosya, soru seti … seçimleri için). `excludeRisk`: eski `accessableProducts` mixin davranışı. */
export const complianceProducts = (accessableProducts, { excludeRisk = false } = {}) =>
  (accessableProducts || []).filter((module) => !NON_PRODUCT_MODULES.includes(module) && !(excludeRisk && module === "RISK"));
